export default __webpack_public_path__ + "media/images/loop2-df6d6117564ec5f326a4fe457cdd7c33.png";